import BusinessEntity, { EntityManager, EntityManagerParameters } from '@xFrame4/business/base/BusinessEntity';
import { BusinessEntityFieldType } from '@xFrame4/business/base/Constants';
import { ManyToManyCollection } from '@xFrame4/business/base/ManyToManyCollection';
import { BusinessEntityWithTranslation, BusinessEntityTranslation, EntityWithTranslationManager, EntityTranslationManager, EntityWithTranslationManagerParameters } from '@xFrame4/business/base/BusinessEntityWithTranslation';


export enum ContactFormEntryStatus
{
    NEW = 'NEW',
    READ = 'READ',
    ACKNOWLEDGED = 'ACKNOWLEDGED',
    SOLVED = 'SOLVED',

}

export class ContactFormEntryGeneratedEntityManager<B extends ContactFormEntryGenerated> extends EntityManager<B>
{

    constructor(parameters: EntityManagerParameters<B>)
    {
        super({
            name: parameters.name ?? 'ContactFormEntry',
            createEntity: parameters.createEntity,
            fields: [
				{ name: 'createdAt', type: BusinessEntityFieldType.DateTime, isInput: false },
				{ name: 'name', type: BusinessEntityFieldType.VarChar },
				{ name: 'email', type: BusinessEntityFieldType.VarChar },
				{ name: 'phone', type: BusinessEntityFieldType.VarChar },
				{ name: 'subject', type: BusinessEntityFieldType.VarChar },
				{ name: 'message', type: BusinessEntityFieldType.Text },
				{ name: 'status', type: BusinessEntityFieldType.VarChar },
				{ name: 'language', type: BusinessEntityFieldType.VarChar },
                ... parameters.fields ?? [],
            ],
            graphQlQueryAlias: parameters.graphQlQueryAlias ?? 'contactFormEntries',
        });
    }

}
/**
 * Represents a contact form entry submitted via the website's contact form.
 */
export class ContactFormEntryGenerated extends BusinessEntity
{
	/** The date and time the contact form entry was created. */
	createdAt!: string;
	/** The name of the contact form entry. */
	name: string = '';
	/** The email address of the contact form entry. */
	email!: string;
	/** The phone number of the contact form entry. */
	phone: string = '';
	/** The subject of the contact form entry. */
	subject: string = '';
	/** The message of the contact form entry. */
	message!: string;
	/** The status of the contact form entry. */
	status!: ContactFormEntryStatus;
	/** 2 letter code (lowercase) for the language of the contact form entry. */
	language: string = '';

}

export default ContactFormEntryGenerated;